import {
  GET_OPERATIONS_FAILURE,
  GET_OPERATIONS_REQUEST,
  GET_OPERATIONS_SUCCESS,
  GET_OPERATION_FOR_DROPDOWN_REQUEST,
  GET_OPERATION_FOR_DROPDOWN_SUCCESS,
  GET_OPERATION_FOR_DROPDOWN_FAILURE,
  GET_OPERATIONS_BY_PO_REQUEST,
  GET_OPERATIONS_BY_PO_SUCCESS,
  GET_OPERATIONS_BY_PO_FAILURE,
} from "./operationsTypes";

const initialState = {
  loading: false,
  labels: [],
  error: "",
};

const getOperationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OPERATIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_OPERATIONS_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_OPERATIONS_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForOperationsWithoutPagination = {
  loading: false,
  labels: [],
  error: "",
};

const getOperationsForDropDownReducer = (
  state = initialStateForOperationsWithoutPagination,
  action
) => {
  switch (action.type) {
    case GET_OPERATION_FOR_DROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_OPERATION_FOR_DROPDOWN_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_OPERATION_FOR_DROPDOWN_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

//   loading: false,
//   labels: [],
//   error: "",
// };

// const getLabelsWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_LABELS_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_LABELS_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         labels: action.payload,
//         error: "",
//       };
//     case GET_LABELS_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         labels: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

// const initialStateForPrinters = {
//   loading: false,
//   printers: [],
//   error: "",
// };

// const getPrintersForLabelCreationReducer = (
//   state = initialStateForPrinters,
//   action
// ) => {
//   switch (action.type) {
//     case GET_PRINTERS_FOR_LABEL_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_PRINTERS_FOR_LABEL_SUCCESS:
//       return {
//         loading: false,
//         printers: action.payload,
//         error: "",
//       };
//     case GET_PRINTERS_FOR_LABEL_FAILURE:
//       return {
//         loading: false,
//         printers: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

const initialStateForOperationsByPo = {
  loading: false,
  operations: [],
  error: "",
};

const getOperationsByPoReducer = (
  state = initialStateForOperationsByPo,
  action
) => {
  switch (action.type) {
    case GET_OPERATIONS_BY_PO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_OPERATIONS_BY_PO_SUCCESS:
      return {
        loading: false,
        operations: action.payload,
        error: "",
      };
    case GET_OPERATIONS_BY_PO_FAILURE:
      return {
        loading: false,
        operations: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getOperationsReducer,
  getOperationsForDropDownReducer,
  getOperationsByPoReducer,
};
